/**
 * Keyboard hints for check-in fields that uppercase their value on every keystroke.
 *
 * iOS predictive text tracks the word it thinks is in the input. When onChange
 * rewrites the value (e.g. `rel` → `REL`), the keyboard's word goes stale and the
 * first suggestion tap is dropped. `autoCapitalize="characters"` makes the
 * keyboard type uppercase so the value is never rewritten under it.
 */
export const UPPERCASE_INPUT_PROPS = {autoCapitalize: 'characters'} as const;

/**
 * Codes, plates and IDs: dictionary suggestions are meaningless here, so turn them off.
 */
export const CODE_INPUT_PROPS = {
  ...UPPERCASE_INPUT_PROPS,
  autoCorrect: 'off',
  autoComplete: 'off',
  spellCheck: false,
} as const;
